module.exports = __webpack_public_path__ + "assets/img/portfolio.ee77c328.jpg";